export default function getPositionFromDrawingPoints({ freeDrawPoints }) {
  return {
    x: Math.min(...freeDrawPoints.map((point) => point.x)),
    y: Math.min(...freeDrawPoints.map((point) => point.y)),
  };
}
